export default [
  {
    title: 'Profile',
    route: 'user-profile',
    icon: 'UserIcon',
  },
]
